import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { user } from "../components/Login/redux/reducers";
import { toasts } from "../components/Shared/Toasts/redux/reducers";
import { createPitch } from "../components/ModalPopup/CreatePitchModal/redux/reducers";
import { createProject } from "../components/ModalPopup/CreateProjectModal/redux/reducers";

export const reducers = combineReducers({
    user,
    createPitch,
    toasts,
    createProject
});

const reduxStore = createStore(
    reducers,
    composeWithDevTools(applyMiddleware()),
);

export default reduxStore;